import { MatSnackBarConfig } from '@angular/material/snack-bar';

import { LoggerType } from '@app/types/logger.types';

export const globalSnackBarConfig: MatSnackBarConfig = {
  duration: 5000,
  horizontalPosition: 'center',
  verticalPosition: 'bottom',
  politeness: 'polite'
};

export interface SnackBarData {
  type: LoggerType;
  title: string;
  message: string;
}
